// Zentrale Konfigurationsdatei der Hitsstube-Landingpage.
// Alle pflegenden Inhalte (DJs, Instagram-URL, Galerie, E-Mail) sind hier gesammelt.

export const SITE = {
  name: "Hitsstube",
  tagline: "OLMA AFTERPARTY IM WAAGHAUS",
  claim: ["Nach der OLMA", "ist vor der Hitsstube."],
  heroIntro:
    "OLMA durch. Nacht noch lange nicht. Deine Crew – eure Hits – ab in die Hitsstube!",
  infoLine: {
    days: "Freitag & Samstag",
    time: "19:00–02:00 Uhr",
    location: "Waaghaus, Marktplatz St. Gallen",
  },

  // Reservation / Kontakt
  email: "waaghaus@kult.sg",
  reservationMailto: "mailto:waaghaus@kult.sg?subject=Reservation%20Hitsstube",
  reservationText:
    "Du kommst mit deiner Crew oder möchtest einen Tisch für eure Gruppe anfragen? Schreib uns direkt – wir melden uns bei dir.",
  reservationAddress: "Waaghaus · Marktplatz · 9000 St. Gallen",
  reservationHint: "Freitag und Samstag, 19:00–02:00 Uhr",

  // Instagram: Sobald eine echte Profiladresse vorliegt, hier eintragen –
  // Button und Verlinkung erscheinen dann automatisch.
  instagramUrl: "https://www.instagram.com/hitsstube/",
  instagramText:
    "Einblicke, Updates und bald auch die DJs: Folge uns und bleib mitten im Geschehen.",
  instagramPlaceholderCount: 4,

  // Veranstalter (ausschliesslich Impressum/Footer)
  organizer: {
    label: "Veranstalter",
    name: "Kult AG",
    street: "Bohl 9",
    city: "9000 St. Gallen",
  },

  // Datenschutz-Link: erst setzen, wenn ein echter Rechtstext existiert.
  privacyUrl: null, // z. B. "/datenschutz"

  // Programm – vier Abende (DJ-Name später hier ersetzen)
  program: [
    { weekday: "Freitag", date: "9. Oktober 2026", time: "19:00–02:00 Uhr", dj: "DJ MARIO", djUrl: "https://djmario.ch/dj-stgallen/" },
    { weekday: "Samstag", date: "10. Oktober 2026", time: "19:00–02:00 Uhr", dj: "Elija, Gian, Jann Saxer" },
    { weekday: "Freitag", date: "16. Oktober 2026", time: "19:00–02:00 Uhr", dj: "DJ Classick" },
    { weekday: "Samstag", date: "17. Oktober 2026", time: "19:00–02:00 Uhr", dj: "Rizzle" },
  ],
  programIntro:
    "Jeder Freitag und Samstag während der OLMA gehört der Hitsstube. Hits only – Stimmung wie am schönsten Après-Ski, Hände hoch und laut mitsingen.",
  programNote: "Endzeit jeweils 02:00 Uhr am Folgetag.",

  // Galerien
  gallery: {
    y2025: {
      title: "Hitsstube 2025",
      text: "Ein Blick zurück auf die Nächte im Waaghaus.",
      images: [
        {
          src: "/images/galerie-2025-1.webp",
          alt: "Hitsstube 2025 im Waaghaus: volles Haus, Festgäste und rotes Partylicht",
        },
      ],
    },
    y2026: {
      title: "Hitsstube 2026",
      emptyText:
        "Die neuen Erinnerungen entstehen bald. Hier findest du nach der OLMA die Bilder der Hitsstube 2026.",
    },
  },
};
